import type { StructuredArrayRowField } from '@/v2/framework/dialog/types'

const statusIconActive = {
  code: 'check-e',
  color: 'var(--nxgds-text-semantic-success-primary, #15a772)',
} as const

const statusIconInactive = {
  code: 'void',
  color: 'var(--nxgds-text-semantic-error-primary, #dd415c)',
} as const

const statusIconGameStatus = {
  code: 'globe-a2',
  color: 'var(--nxgds-text-semantic-info-primary, #0088ef)',
} as const

export const tournamentStatusOptions = [
  {
    value: 1,
    title: 'common.status.active',
    icon: statusIconActive,
  },
  {
    value: 2,
    title: 'common.status.inactive',
    icon: statusIconInactive,
  },
  {
    value: 3,
    title: 'common.status.game_status',
    icon: statusIconGameStatus,
  },
]

export const tournamentGamesStatusOptions = [
  {
    value: 1,
    title: 'common.status.active',
    icon: statusIconActive,
  },
  {
    value: 2,
    title: 'common.status.inactive',
    icon: statusIconInactive,
  },
]

export const tournamentDefaultEventSelectionOptions = [
  { value: 1, title: 'Selected' },
  { value: 2, title: 'Not Selected' },
]

export const GROUPING_CONFIG_ID = 'overviewTournamentGroupingSettings'

export const tournamentGroupingOptions = [
  { value: 'grouped', title: 'tournament_metadata.grouped' },
  { value: 'ungrouped', title: 'tournament_metadata.ungrouped' },
]

export const tournamentCompetitorDisplayOptions = [
  { value: 1, title: 'tournament_metadata.event_competitor_display_type_home_as_first' },
  { value: 2, title: 'tournament_metadata.event_competitor_display_type_away_as_first' },
]

export const displayIdRowFields: StructuredArrayRowField[] = [
  {
    type: 'text-field',
    name: 'prefix',
    label: '',
    placeholder: 'Prefix',
    flex: 1,
  },
  {
    type: 'text-field',
    name: 'rangeFrom',
    label: '',
    placeholder: 'From',
    inputType: 'number',
    flex: 1,
  },
  {
    type: 'text-field',
    name: 'rangeTo',
    label: '',
    placeholder: 'To',
    inputType: 'number',
    flex: 1,
  },
]
